import ContactUs from './contact-us-page.vue';

export default [
	{
		path: 'contactus',
		name: 'contact-us',
		component: ContactUs
	}
];
